module["exports"] = [
  "#{city_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/city.js
// module id = 1315
// module chunks = 1